import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

export const OFFER_ADD_IMAGE_FORM = "offer-plans/ADD_IMAGE";
export const offerAddImageFormTypes = createFormActionTypes(OFFER_ADD_IMAGE_FORM);
export const offerAddImageFormActions = createFormActions(offerAddImageFormTypes);
